import { observer } from 'mobx-react-lite';
import AlarmIcon from 'src/shared/assets/icons/alarm-duotone.svg';
import { Button } from 'src/shared/components/button';

import { FormStore } from '../entities/form.entity';

import styles from './form-messages.module.scss';

type Props = {
  formStore: FormStore;
};

export const FormMessages = observer<Props>(function FormMessages({ formStore }) {
  const { formMessagesService } = formStore;

  if (!formMessagesService.messages.length) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {formMessagesService.messages.map((message) => {
        return (
          <div key={message.entityId} className={styles.messageWrapper}>
            <div className={styles.textWrapper}>
              {message.type === 'error' && <AlarmIcon className={styles.alarmIcon} />}
              <p className={styles.messageText}>{message.text}</p>
            </div>

            <Button
              variant="text"
              className={styles.skipButton}
              onClick={() => formMessagesService.deleteMessage(message.entityId, message.type)}
            >
              Пропустить
            </Button>
          </div>
        );
      })}
    </div>
  );
});
